export const LINE_AND_PARAGRAPH_SPACING_TRIGGER_ID = 'line-and-paragraph-spacing';

export default {
  ADD_SPACE_BEFORE: 'add-space-before',
  ADD_SPACE_AFTER: 'add-space-after',
  REMOVE_SPACE_BEFORE: 'remove-space-before',
  REMOVE_SPACE_AFTER: 'remove-space-after',
  LINE_HEIGHT_AUTO: 'auto',
  LINE_HEIGHT_1: 'line-height-1',
  LINE_HEIGHT_1_1: 'line-height-1.1',
  LINE_HEIGHT_1_2: 'line-height-1.2',
  LINE_HEIGHT_1_3: 'line-height-1.3',
  LINE_HEIGHT_1_5: 'line-height-1.5',
  LINE_HEIGHT_1_6: 'line-height-1.6',
  LINE_HEIGHT_1_7: 'line-height-1.7',
  CUSTOM_SPACING: 'custom',
};
